// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1fJWt","colCheckbox":"styles_colCheckbox__1KEWs"};